import { CATEGORIES } from "@/components/landing/categories";
import { cn } from "@/lib/utils";

// The browse category row, shared by the landing grid and /map.
//
// Mobile: Tinder/Airbnb-style pill chips (icon + label inline) that scroll
// horizontally — active chip flips to ink with white text. The old cramped
// icon-over-label strip only remains on desktop, where it reads like
// Airbnb's category tabs with the underline.
export default function CategoryBar({ value, onPick, className }) {
  return (
    <div className={cn("relative", className)}>
      {/* Mobile pills */}
      <div className="no-scrollbar flex items-center gap-2 overflow-x-auto px-4 py-3 sm:px-6 lg:hidden">
        {CATEGORIES.map((c) => {
          const active = value === c.key;
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => onPick(c.key)}
              className={cn(
                "flex shrink-0 items-center gap-1.5 rounded-full border px-3.5 py-2 text-[13px] font-semibold transition-colors",
                active
                  ? "border-brand-primary bg-brand-primary text-white shadow-sm"
                  : "border-night-line bg-night-surface text-night-text active:bg-night-tint"
              )}
            >
              <c.icon size={15} strokeWidth={active ? 2.2 : 1.8} />
              {c.label}
            </button>
          );
        })}
      </div>

      {/* Desktop tabs (Airbnb style: icon over label, active underline) */}
      <div className="no-scrollbar mx-auto hidden max-w-[1360px] items-center gap-2 overflow-x-auto px-4 sm:px-6 lg:flex lg:px-10">
        {CATEGORIES.map((c) => {
          const active = value === c.key;
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => onPick(c.key)}
              className={cn(
                "flex shrink-0 flex-col items-center gap-1.5 border-b-2 px-3 pb-3 pt-4 text-xs font-medium transition",
                active
                  ? "border-brand-primary text-brand-primary"
                  : "border-transparent text-night-sub hover:border-night-line hover:text-night-text"
              )}
            >
              <c.icon size={22} strokeWidth={active ? 2 : 1.6} />
              {c.label}
            </button>
          );
        })}
      </div>

      {/* Right-edge fade — signals the chip row scrolls on mobile */}
      <span
        className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-night to-transparent lg:hidden"
        aria-hidden="true"
      />
    </div>
  );
}
